import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useSingleton } from "../injection";
import { TimeoutNoticeStore } from "./TimeoutNoticeStore";
import { PopupContainer } from "../../uiLibrary/popup/popupContainer/PopupContainer";
import { Button } from "../../uiLibrary/button";
import { NoticeDialog } from "../../uiLibrary/popup/noticeDialog/NoticeDialog";
import upperFirst from "lodash/upperFirst";

export const TimeoutNotice = observer(() => {
    const store = useSingleton(TimeoutNoticeStore);

    const details = useMemo(
        () => (
            <>
                Timed out operation{store.requests.length > 1 ? "s" : ""}:<br />
                {store.requests.map((x, i) => (
                    <React.Fragment key={i}>
                        {upperFirst(x.currentOperation)}
                        <br />
                    </React.Fragment>
                ))}
            </>
        ),
        [store.requests]
    );

    return (
        <>
            {store.requests.length > 0 && (
                <PopupContainer zIndex={9999}>
                    <NoticeDialog
                        title="This seems to take a long time"
                        description="Do you want to stop the process or keep waiting?"
                        details={details}
                        closeCallback={store.onKeepWaitingClick}
                        testId="timeoutNoticeDialog"
                        buttons={
                            <>
                                <Button
                                    buttonType="neutral"
                                    onClick={store.onStopProcessClick}
                                    testId="stopTheProcess"
                                >
                                    Stop the process
                                </Button>
                                &nbsp;
                                <Button
                                    buttonType="neutral"
                                    onClick={store.onKeepWaitingClick}
                                    testId="keepWaiting"
                                >
                                    Keep waiting
                                </Button>
                            </>
                        }
                    />
                </PopupContainer>
            )}
        </>
    );
});
